import React from 'react';
import { Volume2, Settings } from 'lucide-react';
import { VOICE_PROVIDERS, VOICE_IDS } from '../../config/api';
import { useLocalStorage } from '../../hooks/useLocalStorage';

interface VoiceSelectorProps {
  onVoiceChange: (provider: string, voiceId?: string) => void;
}

const VoiceSelector: React.FC<VoiceSelectorProps> = ({ onVoiceChange }) => {
  const [selectedProvider, setSelectedProvider] = useLocalStorage('voice-provider', VOICE_PROVIDERS.NATIVE);
  const [selectedVoice, setSelectedVoice] = useLocalStorage('voice-id', '');

  const handleProviderChange = (provider: string) => {
    setSelectedProvider(provider);
    onVoiceChange(provider, selectedVoice);
  };

  const handleVoiceChange = (voiceId: string) => {
    setSelectedVoice(voiceId);
    onVoiceChange(selectedProvider, voiceId);
  };

  return (
    <div className="flex items-center gap-2 p-2 bg-surface/80 rounded-lg">
      <Volume2 className="w-5 h-5 text-theme-neon" />
      <select
        value={selectedProvider}
        onChange={(e) => handleProviderChange(e.target.value)}
        className="bg-transparent border-none text-sm focus:outline-none focus:ring-0"
      >
        <option value={VOICE_PROVIDERS.NATIVE}>Voz do Sistema</option>
        <option value={VOICE_PROVIDERS.ELEVENLABS}>ElevenLabs</option>
      </select>
      
      {selectedProvider === VOICE_PROVIDERS.ELEVENLABS && (
        <select
          value={selectedVoice}
          onChange={(e) => handleVoiceChange(e.target.value)}
          className="bg-transparent border-none text-sm focus:outline-none focus:ring-0"
        >
          <option value={VOICE_IDS.JARVIS}>Jarvis (Grave)</option>
          <option value={VOICE_IDS.RICARDO}>Ricardo (Natural)</option>
        </select>
      )}
    </div>
  );
};

export default VoiceSelector;